module.exports = __webpack_public_path__ + "static/img/histoire-01.ab3a1e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-01.png
// module id = 86
// module chunks = 0